import React from "react";
import classes from "./DakshPage.module.css";

import daksh_footer_icon from "../assets/daksh_footer_icon.png";
import daksh_mobile_footer_icon from "../assets/daksh_mobile_footer_icon.png";
import fb_icon from "../assets/fb_icon.png";
import ins_icon from "../assets/ins_icon.png";
import linkedin_icon from "../assets/linkedin_icon.png";
import youtube_icon from "../assets/youtube_icon.png";
import Daksh_logo from "../assets/Daksh_logo.png";

const Footer = () => {
  return (
    <div className={classes.footerSection}>
      <div className={classes.footerInner}>
        <div className={classes.brandBlock}>
          <img
            // src={daksh_footer_icon}
            src={Daksh_logo}
            alt="Daksh Logo"
            className={classes.brandLogo}
          />

          <p className={classes.brandText}>
            HELPING ORGANIZATION MAKE SMARTER, FASTER HIRING DECISIONS WITH
            AI-DRIVEN CANDIDATE INTELLIGENCE.
          </p>
        </div>

        <div className={classes.linksWrapper}>
          {/* CONNECT */}
          <div className={classes.linksColumn}>
            <h4 className={classes.contact}>CONNECT</h4>
            {/* <p className={classes.footerLink}>BLOG</p> */}
            <div className={classes.socialRow}>
              <a
                href="https://www.facebook.com/setuailearning?rdid=n8UO8bcgCP5W8fFD&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BVAmSpYrx%2F#"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialLink}
              >
                <img src={fb_icon} alt="Facebook" className={classes.fb_icon} />
                <span className={classes.fb}>Facebook</span>
              </a>
            </div>

            <div className={classes.socialRow}>
              <a
                href="https://www.instagram.com/setuschool/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialLink}
              >
                <img
                  src={ins_icon}
                  alt="Instagram"
                  className={classes.ins_icon}
                />
                <span className={classes.ins}>Instagram</span>
              </a>
            </div>

            <div className={classes.socialRow}>
              <a
                href="https://www.linkedin.com/company/setu-school/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialLink}
              >
                <img
                  src={linkedin_icon}
                  alt="LinkedIn"
                  className={classes.linkedin_icon}
                />
                <span className={classes.linkein}>LinkedIn</span>
              </a>
            </div>

            <div className={classes.socialRow}>
              <a
                href="https://www.youtube.com/@setuschool"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialLink}
              >
                <img
                  src={youtube_icon}
                  alt="YouTube"
                  className={classes.youtube_icon}
                />
                <span className={classes.youtube}>YouTube</span>
              </a>
            </div>
          </div>

          {/* RESOURCES */}
          {/* <div className={classes.linksColumn}>
            <h4 className={classes.resources}>RESOURCES</h4>
            <p className={classes.footerLink}>SECURITY</p>
            <p className={classes.footerLink}>Documentation</p>
            <p className={classes.footerLink}>How It Works</p>
          </div> */}

          <div className={classes.linksColumn}>
            <h4 className={classes.status}>STATUS</h4>
            <div className={classes.statusIndicator}>
              <span className={classes.statusDot}></span>
              <span className={classes.beta}>Beta Version</span>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.footerBottom}>
        <p className={classes.daksh_ai}>
          © 2026 DAKSH.AI // ALL RIGHTS RESERVED
        </p>
        <p className={classes.built}>[ BUILT FOR BETTER HIRING ]</p>
      </div>
    </div>
  );
};

export default Footer;
